/**
 * The sidebar, in one place.
 *
 * Only what this phase actually serves. The greyed-out entries - Students,
 * Applications, Dashboard, Enquiries, Wallet, Commission - are gone rather than
 * disabled: a row of six permanently dead links is not navigation, it is a
 * roadmap in the wrong place, and it made the product look unfinished on every
 * screen.
 *
 * Search Programs and Universities are the two tabs in the top navigation, so
 * repeating them here was a duplicate of the same two links. They have been
 * removed. Nothing else was ever in this list, so with it empty the rail is not
 * rendered at all - that is what keeps an empty 186px gutter from being left
 * behind where the links used to be.
 *
 * The first three parked entries - Students, Applications, Dashboard (see
 * db-filter's _parked/) - get their row back here when they return, and the
 * rail comes back with them.
 */
const ITEMS = [];

export function SideNav({ current, onNavigate }) {
  if (ITEMS.length === 0) return null;

  return (
    <nav>
      {ITEMS.map((item) => (item.soon ? (
        <a key={item.key} href="#" className="soon" title={item.why}>{item.label}</a>
      ) : (
        <a
          key={item.key}
          href={item.href}
          className={item.key === current ? 'on' : undefined}
          onClick={onNavigate ? (e) => { e.preventDefault(); onNavigate(item.href); } : undefined}
        >
          {item.label}
        </a>
      )))}
    </nav>
  );
}
